module.exports = __webpack_public_path__ + "static/media/ur-PK.eae3201e.md";